import { Component } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {

    constructor(
        private menuController: MenuController
    ) { }

    ionViewDidEnter() {
        setTimeout(() => {
            this.menuController.enable(false, 'main-menu');
        }, 100);
    }

}
